import { render, staticRenderFns } from "./AdditionalServicePriceList.vue?vue&type=template&id=20e1d82a&scoped=true&"
import script from "./AdditionalServicePriceList.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1d82a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e1d82a')) {
      api.createRecord('20e1d82a', component.options)
    } else {
      api.reload('20e1d82a', component.options)
    }
    module.hot.accept("./AdditionalServicePriceList.vue?vue&type=template&id=20e1d82a&scoped=true&", function () {
      api.rerender('20e1d82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/price/AdditionalServicePriceList.vue"
export default component.exports